import React, { Component } from 'react';
import { string, shape, func } from 'prop-types';
import withApplicationConfig from 'containers/withApplicationConfig';
import { withTracking } from 'components/tracking';
import { withRouter } from 'react-router';
import {
  Container,
  Row,
  Column,
  Heading,
  Paragraph,
  HtmlParser,
  LazyLoadImg,
  Block,
} from 'components/common';
import styleVariables from 'styles/variables';
import './ErrorPage.scss';

class ErrorPage extends Component {
  constructor(props) {
    super(props);
    // side effect mutating the original context object
    const { staticContext, errorCode } = props;
    if (!staticContext?.status && errorCode === 404) {
      staticContext.status = 404;
    }
  }

  componentDidMount() {
    const { location, errorCode, track } = this.props;
    track({ data: { event: 'pageError', errorPage: { code: errorCode, path: location ? location.pathname : null } } });
  }

  render() {
    const { language } = this.props;
    const {
      title,
      subTitle,
      p1,
      p2,
      errorText,
      desktopImageUrl,
      mobileImageUrl,
      imgAlt,
      errorCode,
    } = Object.assign({}, this?.props?.[language], this?.props);
    return (
      <div
        className="error-page"
        data-selector-type="error-page"
        data-selector-value={errorCode}
      >
        <Block>
          <Container className="container-wrapper">
            <Row>
              <Column xs={12} className="mobile-image-col">
                <LazyLoadImg
                  src={mobileImageUrl}
                  className="mobile-image"
                  alt={imgAlt}
                />
              </Column>
              <Column md={4}>
                <Heading
                  className="error-heading"
                  as="h1"
                >
                  {title}
                </Heading>
                <Heading as="h2">{subTitle}</Heading>
                <Paragraph><HtmlParser htmlString={p1} /></Paragraph>
                <Paragraph><HtmlParser htmlString={p2} /></Paragraph>
                <Paragraph
                  style={{
                    marginTop: styleVariables.spacingMassive,
                  }}
                >
                  {`${errorText} ${errorCode}`}
                </Paragraph>
              </Column>
              <Column md={8} className="desktop-image-col">
                <LazyLoadImg
                  src={desktopImageUrl}
                  className="desktop-image"
                  alt={imgAlt}
                />
              </Column>
            </Row>
          </Container>
        </Block>
      </div>
    );
  }
}

ErrorPage.defaultProps = {
  errorCode: '',
  location: {},
  staticContext: {},
  track: null,
  language: '',
};

ErrorPage.propTypes = {
  errorCode: string,
  location: shape({}),
  staticContext: shape({}),
  track: func,
  language: string,
};

export default withTracking(withRouter(withApplicationConfig(ErrorPage, 'error')));
